import React, {Component, PropTypes} from 'react'
import GetStartedWidget from './GetStartedWidget'
import { saveEdgebetFilterInCache, getCachedEdgebetFilters } from 'utils/cache'
import Select from 'react-select'


export default class FilteringIntro extends Component {

  constructor(props) {
    super(props)
    this.onChange = this.onChange.bind(this)
    this.save = this.save.bind(this)
    this.state = {
      filters: getCachedEdgebetFilters()
    }
  }

  componentDidMount() {
    window.analytics.track('Get started', {
      index: 3
    })
  }

  onChange(key, value) {
    let filters = Object.assign({}, this.state.filters)
    filters[key] = value
    this.setState({
      filters
    })
    saveEdgebetFilterInCache(key, value)

  }
  save(e) {
    e.preventDefault()
    return this.props.onComplete()
  }

  render() {
    return (
      <GetStartedWidget heading="Now let's personalize Edgebet.">
        <p className='description'>Here you can familiarize yourself with our filters</p>
        <FilterFormGroup
          options={[{value: 1, label: 'Next 12 hours (recommended)'}, {value: 0, label: 'Next 2 days'}]}
          stateKey='next12hours'
          onChange={this.onChange}
          label="How far in advance you want to be placing bets"
          hint='We recommend you placing bets no more than 12 hours before kickoff.'
          value={this.state.filters.next12hours}
        />
        <FilterFormGroup
          options={[{value: 1, label: 'Low risk (recommended)'}, {value: 0, label: 'All edges'}]}
          stateKey='lowRisk'
          onChange={this.onChange}
          value={this.state.filters.lowRisk}
          hint='Low risk would only you show you edgebets with odds lower than 4.'
        />
        <FilterFormGroup
          options={[{value: 1, label: 'Recommended leagues'}, {value: 0, label: 'All leagues'}]}
          stateKey='recommendedLeagues'
          onChange={this.onChange}
          value={this.state.filters.recommendedLeagues}
          hint='Bookmakers don’t like winning players, by placing on the recommended leagues you’ll stay under the radar'
          label='What leagues you would place bets on'
        />
        <p>
          You can always change these filters by pressing the&nbsp;
          <i className='ionicons ion-ios-gear'></i>
          &nbsp;button on edgebets</p>
        <div className='form-group'>
          <div className='col-xs-12'>
            <button type='button' onClick={this.save} className='btn btn-success'>Take me to Notifications</button>
          </div>
        </div>
      </GetStartedWidget>
    )

  }
}

class FilterFormGroup extends Component {

  onChange(e) {
    this.props.onChange(this.props.stateKey, e.value)
  }

  shouldComponentUpdate(nextProps) {
    return this.props.value !== nextProps.value
  }

  render() {
    return (
      <div className='form-group'>
        <label className='control-label'>{ this.props.hint }</label>
        <Select
          name={this.props.stateKey}
          options={this.props.options}
          onChange={this.onChange.bind(this)}
          value={this.props.value}
          clearable={false}
        />
      </div>
    )
  }
}

FilteringIntro.propTypes = {
  bookmakerLists: PropTypes.object.isRequired,
  onComplete: PropTypes.func.isRequired
}



/** WEBPACK FOOTER **
 ** ./src/components/getstarted/FilteringIntro.js
 **/